import { useMemo } from 'react';

export type MeasureKey = 'Net' | 'D' | 'Y' | 'N';

export default function FieldSelector({
  fields,
  selected,
  onToggle,
  measure,
  onMeasureChange
}: {
  fields: Array<{ code: string; group: string; sub: string }>;
  selected: Set<string>;
  onToggle: (code: string) => void;
  measure: MeasureKey;
  onMeasureChange: (m: MeasureKey) => void;
}) {
  const grouped = useMemo(() => {
    const g = new Map<string, Array<{ code: string; sub: string }>>();
    for (const f of fields) {
      if (!g.has(f.group)) g.set(f.group, []);
      g.get(f.group)!.push({ code: f.code, sub: f.sub });
    }
    for (const arr of g.values()) arr.sort((a,b)=>a.sub.localeCompare(b.sub, 'tr'));
    return Array.from(g.entries()).sort((a,b)=>a[0].localeCompare(b[0], 'tr'));
  }, [fields]);

  return (
    <div className="rounded-lg border bg-white p-4 space-y-4">
      <div className="flex items-center gap-3 text-sm">
        <span className="font-medium">Ölçü:</span>
        <select className="rounded-md border px-2 py-1" value={measure} onChange={(e)=>onMeasureChange(e.target.value as MeasureKey)}>
          {(['Net','D','Y','N'] as MeasureKey[]).map(m=> <option key={m} value={m}>{m}</option>)}
        </select>
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        {grouped.map(([group, arr]) => (
          <div key={group} className="border rounded-md p-3">
            <div className="mb-2 text-sm font-semibold">{group}</div>
            <div className="grid gap-2 sm:grid-cols-2">
              {arr.map(item => (
                <label key={item.code} className="flex items-center gap-2 text-sm">
                  <input type="checkbox" checked={selected.has(item.code)} onChange={()=>onToggle(item.code)} />
                  <span>{item.sub}</span>
                </label>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}


